module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader_container"
  }, [_c('div', {
    staticClass: "loader_content"
  }, [_c('img', {
    attrs: {
      "src": require("../img/loading-black.gif")
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.message),
      expression: "message"
    }],
    staticStyle: {
      "margin-left": "20px",
      "vertical-align": "middle"
    }
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.message),
      expression: "!message"
    }],
    staticStyle: {
      "margin-left": "20px",
      "vertical-align": "middle"
    }
  }, [_vm._v("Loading...")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ea139fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
// module id = 916
// module chunks = 1